// extracted by mini-css-extract-plugin
export default {"container":"amount-summary_container__+3B1K","label":"amount-summary_label__Ave5-","amount":"amount-summary_amount__UwNsa"};